// actual  conversion code starts here

const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']
const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety']
const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen']

function convertTens(num) {
  if (num < 10) return ones[num]
  if (num >= 10 && num < 20) return teens[num - 10]

  return `${tens[Math.floor(num / 10)]} ${ones[num % 10]}`
}

function convertHundreds(num) {
  if (num > 99) {
    return `${ones[Math.floor(num / 100)]} hundred ${convertTens(num % 100)}`
  }
  return convertTens(num)
}

function convertThousands(num) {
  if (num >= 1000) {
    return `${convertHundreds(Math.floor(num / 1000))} thousand ${convertHundreds(num % 1000)}`
  }
  return convertHundreds(num)
}

function convertMillions(num) {
  if (num >= 1000000) {
    return `${convertMillions(Math.floor(num / 1000000))} million ${convertThousands(num % 1000000)}`
  }
  return convertThousands(num)
}

export default function numberToWords(num) {
  if (isNaN(num)) return 'NaN' // eslint-disable-line no-restricted-globals
  if (num === 0) return 'zero'

  const prefix = num < 0 ? 'negative ' : ''
  const absNum = Math.abs(num) // ensure we're working with a positive number

  return `${prefix}${convertMillions(absNum).trim()}`
}
